import {AfterViewInit, Component} from '@angular/core';
import {ReserveConfirmDateFragmentController} from './ReserveConfirmDateFragmentController';
import {MatDialog} from '@angular/material/dialog';
import {BaseViewUI} from '../../../../../../BaseUI/BaseViewUI/BaseViewUI';
import {Router} from '@angular/router';
import {ReservationSaveDTOInterface} from '../../../../../../../DTO/ReservationSaveDTOInterface';
import { AppSingletonUtil } from '../../../../../../../Util/AppSingletonUtil';
import { StorageService } from '../../../../../../../Service/StorageService';

@Component({
	selector: 'app-reserve-component',
	templateUrl: './ReserveConfirmDateFragmentComponent.html',
	styleUrls: ['../ReserveCreateFormLayout.scss', './ReserveConfirmDateFragmentComponent.scss'],
})
export class ReserveConfirmDateFragmentComponent extends BaseViewUI implements AfterViewInit {

	// 紐付いたコントローラー
	public combineCtrl: ReserveConfirmDateFragmentController;

	public eventConfirm: (reserve: ReservationSaveDTOInterface) => void;
	public eventSaveReservation: (reserve: ReservationSaveDTOInterface) => void;
	public eventSetReserveSaveData: (reserve: ReservationSaveDTOInterface) => void;
	public eventGotoNext: (reserve: ReservationSaveDTOInterface) => void;
	public eventSelectDate: () => void;
	public reserveModel: ReservationSaveDTOInterface = {} as ReservationSaveDTOInterface;

	public isUserLoggedIn = false;
	/**
	 * constructor
	 */
	constructor(public dialogCtrl: MatDialog,
				public route: Router) {

		super();

		// コントローラーの生成
		this.createController(ReserveConfirmDateFragmentController);

	}

	/**
	 * ngAfterViewInit
	 *
	 * Angularのライフサイクル
	 * ビューの初期化後に一度だけ実行される
	 */
	public async ngAfterViewInit() {
	}

	/**
	 * 開始処理
	 */
	public async start() {
		// YahooのCV計測　予約完了まで保持する必要がある
		const route = AppSingletonUtil.getActivatedRoute();
		const query = route.snapshot.queryParams;
		const yclid = query.yclid;
		if (yclid) {
			sessionStorage.setItem('yclid', yclid);
		}
	}


	/**
	 * 日時選択画面に戻る
	 */
	public async cancel() {
		await this.eventSelectDate();
	}


	/**
	 * 次のアクションへ移動、親から設定される
	 * ログインしていれば確認画面、ログインしていなければログイン画面の表示
	 */
	public async onClickNext() {
		await this.eventGotoNext(this.reserveModel);
	}
}

